import { StatePropertyRef } from '../../canvas/ExtendableStore';

export interface ParticipantStripInfo {
    enabled: boolean;
}

export const CreateParticipantStripInfo = (enabled: boolean) =>
    ({ enabled }) as ParticipantStripInfo;

export const ParticipantStripInfo = StatePropertyRef<ParticipantStripInfo>('participantStrip', CreateParticipantStripInfo(true));
